import {Component, inject} from '@angular/core';
import {AdditionalActionHeaderComponent} from "../additional-action-header/additional-action-header.component";
import {FooterComponent} from "../../../common/footer/footer.component";
import {LocaleService} from "../../../../locale/locale.service";

@Component({
  selector: 'app-data-privacy',
  imports: [
    AdditionalActionHeaderComponent,
    FooterComponent
  ],
  templateUrl: './data-privacy.component.html',
  styleUrl: './data-privacy.component.css'
})
export class DataPrivacyComponent {
  locale = inject(LocaleService);
}
